import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
type LogoProps = {
  size: number;
  style?: Record<string, unknown>;
}; // tslint:disable

export default class PaperBillCompany extends React.Component<LogoProps> {
  getWidth() {
    if (this.props.style && this.props.style['size']['width']) {
      return this.props.style['size']['width'];
    } else {
      return 40;
    }
  }

  getHeight() {
    if (this.props.style && this.props.style['size']['height']) {
      return this.props.style['size']['height'];
    } else {
      return 40;
    }
  }

  render() {
    return (
      <>
        <Svg
          width={this.getWidth()}
          height={this.getHeight()}
          viewBox="0 0 40 40"
          fill="none"
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.667 6.667H3.333A3.343 3.343 0 000 10V30c0 1.833 1.5 3.333 3.333 3.333h33.334C38.5 33.333 40 31.833 40 30V10c0-1.833-1.5-3.333-3.333-3.333zm-35 7.5v11.666A4.167 4.167 0 017.5 31.667H32.5a4.167 4.167 0 015.834-5.834V14.167A4.167 4.167 0 0132.5 8.333h-25a4.167 4.167 0 01-5.834 5.834zM28.333 20a8.333 8.333 0 11-16.666 0 8.333 8.333 0 0116.666 0zm-10.856 5v-1.126h1.927v-7.11l-1.927.482v-1.159l3.86-.963v8.75h1.928V25h-5.788z"
            fill="#22212D"
          />
        </Svg>
      </>
    );
  }
}
